/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Map_TitleInputs */

const en_ticket_map_title = /** @type {(inputs: Ticket_Map_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Location`)
};

const ja_ticket_map_title = /** @type {(inputs: Ticket_Map_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現在地`)
};

const fr_ticket_map_title = /** @type {(inputs: Ticket_Map_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre position`)
};

const de_ticket_map_title = /** @type {(inputs: Ticket_Map_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihr Standort`)
};

/**
* | output |
* | --- |
* | "Your Location" |
*
* @param {Ticket_Map_TitleInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_map_title = /** @type {((inputs?: Ticket_Map_TitleInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Map_TitleInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_map_title(inputs)
	if (locale === "ja") return ja_ticket_map_title(inputs)
	if (locale === "fr") return fr_ticket_map_title(inputs)
	return de_ticket_map_title(inputs)
});